import { NavigateFunction } from 'react-router-dom';

import { Shop } from '../models/shop';
import { ExistingShopRouteState } from '../route_states/existing.shop.route.state';
import { setCurrentStoreSecretKey, setCurrentStoreTitle } from '../cache/current.store.cache';

export const shopMatches = (shop: Shop, query: string) => {
  const needle = query.toLowerCase();
  return shop.shop_name.toLowerCase().includes(needle)
    || !!shop.visible_name?.toLowerCase().includes(needle)
    || shop.shop_id.toLowerCase().includes(needle);
};

// Opens a shop's settings. From inside another shop it keeps the current settings
// page and reloads, so no page keeps the previous shop's state; the shop name then
// comes from the current-store cache.
export const openShop = (shop: Shop, navigate: NavigateFunction, currentShopId?: string) => {
  const { shop_id, shop_name, secret_key } = shop;
  setCurrentStoreTitle(shop_name);
  setCurrentStoreSecretKey(secret_key);
  if (currentShopId && window.location.pathname.includes('existingshop')) {
    window.location.href = window.location.origin + window.location.pathname.replace(currentShopId, shop_id);
  } else {
    navigate(`/existingshop/${shop_id}/fitquiz/`, {
      state: { shop_name, shop_key: secret_key } as ExistingShopRouteState,
    });
  }
};
